/**
 * Created by lowdev on 1/4/18.
 *
 * Fetch JS Doc : https://developer.mozilla.org/fr/docs/Web/API/Fetch_API/Using_Fetch
 * @example : https://github.com/mdn/fetch-examples/
 *
 * @class OpenDateService
 * @example
 var config = {
         api: {
            staff: {
              detail: '/url/details/<id>'
              list: '/url/details/'
            }
         }
     }
 var service = new StaffService(config);
 service.get().then((success => {
            console.log(success);
     }))
 * @returns {Promise}
 */

import * as Cookies from 'js-cookie'

const CSRFToken = Cookies.get('csrftoken')

export default class OpenDateService {
  constructor (config, key) {
    this.api = config.api[key]
    this.headers = {
      'X-CSRFToken': CSRFToken,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }

  get (id) {
    return new Promise((resolve, reject) => {
      fetch(this.api.details.replace('<id>', String(id)), {
        method: 'GET',
        credentials: 'include',
        headers: this.headers
      }).then((response) => {
        if (response.status !== 200) {
          // Not success
          resolve(response.json())
        } else {
          // success
          resolve(response.json().then(data => data))
        }
      }).catch(err => {
        // Service Error
        reject(err)
      })
    })
  }

  remove (id) {
    throw {name : "NotImplementedError", message : "too lazy to implement"};
  }

  getList () {
    throw {name : "NotImplementedError", message : "too lazy to implement"};
  }
}



// WEBPACK FOOTER //
// ./activity/static/activity/js/services/OpenDateService.js